export default __webpack_public_path__ + "static/media/Pennisula.b2a94d8e.jpg";